
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher"

export class CountEInvoiceContractQuery {
    constructor(
        private readonly dispatcher: QueryDispatcher
    ) {}
    
    async run(client:boolean): Promise<any> {
        let args = {client: client}
        return await this.dispatcher.dispatch('count.user.active.einvoice.contracts', args)
    }
}